var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_450_1709)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3974 13.452H18.7954V12.3193H15.3974V13.452ZM17.6627 6.65613H1.80579V17.9825C1.80579 18.6077 2.31321 19.1151 2.93842 19.1151H17.6627C18.2879 19.1151 18.7954 18.6077 18.7954 17.9825V14.5846H14.8311C14.5185 14.5846 14.2648 14.3314 14.2648 14.0183V11.753C14.2648 11.4404 14.5185 11.1867 14.8311 11.1867H18.7954V7.78877C18.7954 7.16355 18.2879 6.65613 17.6627 6.65613ZM17.6627 1.55926C17.6627 1.24608 17.5291 1.07278 17.238 0.95782C17.0137 0.868908 16.7957 0.922149 16.5301 0.992939L1.80579 5.52349H17.6627V1.55926Z",
    fill: "#E5E5E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_450_1709"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.6885,
    height: 18.6885,
    fill: "white",
    transform: "translate(0.956299 0.426636)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.f72e2d97c574df08bced963c6389fa9c.svg";
export { ForwardRef as ReactComponent };